import { render, staticRenderFns } from "./QuickReplyEditor.modal.vue?vue&type=template&id=2a5b0682&scoped=true&"
import script from "./QuickReplyEditor.modal.vue?vue&type=script&lang=js&"
export * from "./QuickReplyEditor.modal.vue?vue&type=script&lang=js&"
import style0 from "./QuickReplyEditor.modal.vue?vue&type=style&index=0&id=2a5b0682&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5b0682",
  null
  
)

export default component.exports